export const prepareDailyReportProp = (data: any) => {
  let _manageAccountState: any = { ...data };
  _manageAccountState["emailSubscription"] = false;
  _manageAccountState["emailSubscriptionV2"] = false;
  switch (_manageAccountState.dailyReport) {
    case "V1V2": {
      _manageAccountState.emailSubscription = true;
      _manageAccountState.emailSubscriptionV2 = true;
      break;
    }
    case "LEAD": {
      _manageAccountState.emailSubscription = false;
      _manageAccountState.emailSubscriptionV2 = true;
      break;
    }
    case "V1": {
      _manageAccountState.emailSubscription = true;

      break;
    }
    case "V2": {
      _manageAccountState.emailSubscriptionV2 = true;

      break;
    }
    default: {
      // DISABLED - already set
    }
  }
  delete _manageAccountState.dailyReport;
  return _manageAccountState;
};

export const getProductCode = (productOptions: any, productId: any) => {
  if (productOptions.length > 0) {
    let arr = productOptions?.filter((item: any) => item.value === productId);
    return arr[0].productCode;
  }
  return null;
};

export const userPropsToFetch = [
  "firstName",
  "lastName",
  "email",
  "product",
  "level",
  "owner",
  "group",
  "creationTime",
  "active",
  "levelUpdate",
  "permissions",
  "emailSubscription",
  "emailSubscriptionV2",
];

export const userTypes = [
  { value: "PARTNER", label: "Partner", checked: false },
  { value: "SUBSCRIBER", label: "Subscriber", checked: false },
  { value: "TRIAL", label: "Trial", checked: false },
  { value: "INTERNAL", label: "Internal", checked: false },
  { value: "FREE", label: "Free", checked: false },
  { value: "LEAD", label: "Lead", checked: false },
];

export const applicationMap: any = {
  Trendrating: "application",
  "Excel Add-In": "excel",
  "Daily Email": "mail",
  "Smart Manager": "manager",
};

export const periodValues: any[] = [
  { value: "today", label: "Today" },
  { value: "1D", label: "1 Day" },
  { value: "1W", label: "1 Week" },
  { value: "1M", label: "1 Month" },
  { value: "3", label: "3 Months" },
  { value: "6", label: "6 Months" },
  { value: "12", label: "12 Months" },
];

type productCodeType =
  | "STANDARD"
  | "PREMIUM"
  | "ADVANCED"
  | "SYSTEMATIC_ENGINE"
  | "SYSTEMATIC_ENGINE_AND_PREMIUM"
  | "RISE"
  | "DISPERSION";
export const checkIssues = (
  oldProductCode: productCodeType,
  newProductCode: productCodeType
) => {
  if (oldProductCode === newProductCode) {
    return null;
  } else {
    const proprietaryObjects: any = {
      1: "All Portfolios and Baskets will be lost",
      6: "All renking will be lost",
      2: "All Strategies will be lost",
      3: "All SMS will be lost",
      4: "The strategies will contain hidden parameters",
      5: "All premium strategies will be lost",
    };
    const subscriptions: any = {
      1: "Subscribed Raking will be removed",
      2: "Subscribed Portfolio and Basket Will be removed",
      3: "Subscribe Strategies will be removed",
      4: "Subscribed SMS will be removed",
    };

    let proprietaryObjectsIssuesIndexes: number[] = [];
    let subscriptionsIssuesIndexes: number[] = [];

    switch (oldProductCode) {
      case "ADVANCED":
        switch (newProductCode) {
          case "STANDARD":
            proprietaryObjectsIssuesIndexes = [1, 6];
            subscriptionsIssuesIndexes = [1, 3, 4];
            break;
          case "DISPERSION":
            proprietaryObjectsIssuesIndexes = [2, 6];
            subscriptionsIssuesIndexes = [1, 2, 3, 4];
            break;
          case "RISE":
            proprietaryObjectsIssuesIndexes = [2, 6];
            subscriptionsIssuesIndexes = [1, 2, 4];
            break;
          case "PREMIUM":
            proprietaryObjectsIssuesIndexes = [2, 6];
            subscriptionsIssuesIndexes = [3];
            break;
        }
        break;
      case "PREMIUM":
        switch (newProductCode) {
          case "STANDARD":
            proprietaryObjectsIssuesIndexes = [1];
            subscriptionsIssuesIndexes = [1];
            break;
          case "DISPERSION":
            proprietaryObjectsIssuesIndexes = [1, 2];
            subscriptionsIssuesIndexes = [1, 3];
            break;
          case "RISE":
            proprietaryObjectsIssuesIndexes = [2, 6];
            subscriptionsIssuesIndexes = [1, 3];
            break;
        }
        break;
      case "SYSTEMATIC_ENGINE":
        switch (newProductCode) {
          case "STANDARD":
          case "DISPERSION":
            proprietaryObjectsIssuesIndexes = [1, 2, 3, 6];
            subscriptionsIssuesIndexes = [1, 3, 4];
            break;
          case "ADVANCED":
            proprietaryObjectsIssuesIndexes = [3, 4];
            subscriptionsIssuesIndexes = [1, 4];
            break;
          case "RISE":
            proprietaryObjectsIssuesIndexes = [1, 2, 3, 6];
            subscriptionsIssuesIndexes = [1, 3, 4];
            break;
          case "PREMIUM":
            proprietaryObjectsIssuesIndexes = [2, 4];
            subscriptionsIssuesIndexes = [3, 4];
            break;
        }
        break;
      case "SYSTEMATIC_ENGINE_AND_PREMIUM":
        switch (newProductCode) {
          case "STANDARD":
            proprietaryObjectsIssuesIndexes = [1, 2, 3, 6];
            subscriptionsIssuesIndexes = [1, 3, 4];
            break;
          case "DISPERSION":
            proprietaryObjectsIssuesIndexes = [1, 2, 3, 6];
            subscriptionsIssuesIndexes = [1, 2, 3, 4];
            break;
          case "ADVANCED":
            proprietaryObjectsIssuesIndexes = [3, 4];
            subscriptionsIssuesIndexes = [4];
            break;
          case "RISE":
            proprietaryObjectsIssuesIndexes = [1, 2, 3, 6];
            subscriptionsIssuesIndexes = [1, 2, 3, 4];
            break;
          case "PREMIUM":
            proprietaryObjectsIssuesIndexes = [2, 4];
            subscriptionsIssuesIndexes = [4];
            break;
        }
        break;
    }

    if (
      proprietaryObjectsIssuesIndexes.length === 0 &&
      subscriptionsIssuesIndexes.length === 0
    ) {
      return null;
    }

    let proprietaryObjectsIssues: string[] =
      proprietaryObjectsIssuesIndexes.map(
        (index: number) => proprietaryObjects[index.toString()]
      );
    let subscriptionsIssues: string[] = subscriptionsIssuesIndexes.map(
      (index: number) => subscriptions[index.toString()]
    );
    return {
      subscriptionsIssues: subscriptionsIssues,
      proprietaryObjectsIssues: proprietaryObjectsIssues,
    };
  }
};
